// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__yQEGO","mod-inline":"icon_mod-inline__k_yeM","mod-maxwidth":"icon_mod-maxwidth__jbi_r","mod-nofill":"icon_mod-nofill__IGwN0","raw":"icon_raw___xZ8M"};